// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__0qu7y","OrgInfo":"Footer_OrgInfo__vfcvV","Copyright":"Footer_Copyright__HxOEX"};